// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import ClipboardController from "./clipboard_controller";
application.register("clipboard", ClipboardController);

import DropdownController from "./dropdown_controller";
application.register("dropdown", DropdownController);

import FlashMessageController from "./flash_message_controller";
application.register("flash-message", FlashMessageController);

import GameSetupController from "./game_setup_controller";
application.register("game-setup", GameSetupController);

import HelloController from "./hello_controller";
application.register("hello", HelloController);

import HelpController from "./help_controller";
application.register("help", HelpController);

import HotColdController from "./hot_cold_controller";
application.register("hot-cold", HotColdController);

import MapController from "./map_controller";
application.register("map", MapController);

import MapToggleController from "./map_toggle_controller";
application.register("map-toggle", MapToggleController);

import ModalController from "./modal_controller";
application.register("modal", ModalController);

import PowerUpController from "./power_up_controller";
application.register("power-up", PowerUpController);

import ScoreController from "./score_controller";
application.register("score", ScoreController);

import SpotTimerController from "./spot_timer_controller";
application.register("spot-timer", SpotTimerController);

import YoutubeController from "./youtube_controller";
application.register("youtube", YoutubeController);
